import { render, staticRenderFns } from "./StudyIntroduction.vue?vue&type=template&id=2f73c19a&scoped=true"
import script from "./StudyIntroduction.vue?vue&type=script&lang=js"
export * from "./StudyIntroduction.vue?vue&type=script&lang=js"
import style0 from "./StudyIntroduction.vue?vue&type=style&index=0&id=2f73c19a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f73c19a",
  null
  
)

export default component.exports